function initInstantsearch(collection, options) {
  const searchClient = algoliasearch(
    'F9HCDR2SMH',
    '6796a647ff7046ff14ebe5a07a5c8ec0'
  );

  const indexName = 'shopify_products';
  const insightsMiddleware = instantsearch.middlewares.createInsightsMiddleware(
    {
      insightsClient: null,
      onEvent: event => {
        window.trackAlgoliaEvent(event);
      }
    }
  );
  const search = instantsearch({
    indexName,
    searchClient,
    routing: {
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[indexName];
          return {
            q: indexUiState.query,
            brands:
              indexUiState.refinementList && indexUiState.refinementList.vendor,
            collections:
              indexUiState.refinementList && indexUiState.refinementList.tags,
            type:
              indexUiState.refinementList &&
              indexUiState.refinementList.product_type,
            color:
              indexUiState.refinementList &&
              indexUiState.refinementList['options.color'],
            size:
              indexUiState.refinementList &&
              indexUiState.refinementList['options.size'],
            page: indexUiState.page
          };
        },
        routeToState(routeState) {
          return {
            [indexName]: {
              query: routeState.q,
              refinementList: {
                tags: routeState.collections,
                vendor: routeState.brands,
                product_type: routeState.type,
                'options.color': routeState.color,
                'options.size': routeState.size
              },
              page: routeState.page
            }
          };
        }
      }
    }
  });

  const SORT_OPTIONS = [
    { label: 'Best Sellers', value: 'shopify_products' },
    { label: 'New', value: 'shopify_products_published_at_desc' },
    { label: '$$$ to $', value: 'shopify_products_price_desc' },
    { label: '$ to $$$', value: 'shopify_products_price_asc' }
  ];

  const customHits = instantsearch.connectors.connectInfiniteHits(
    (renderOptions, isFirstRender) => {
      let params = { ...renderOptions, infiniteScroll: true };
      if (options && options.promoTiles) {
        params.promoTiles = options.promoTiles;
      }
      return renderProducts(params, isFirstRender);
    }
  );
  const search_searchResults = customHits({
    container: document.querySelector('#search-products')
  });
  let configureOptions = {
    hitsPerPage: 36,
    clickAnalytics: true,
    getRankingInfo: true,
    distinct: true
  };
  if (collection) {
    configureOptions.filters = `collections:${collection}`;
  }
  const configure = instantsearch.widgets.configure(configureOptions);
  const clearRefinements = instantsearch.widgets.clearRefinements({
    container: '#clear-refinements',
    templates: {
      resetLabel: 'Clear filters'
    }
  });
  const currentRefinements = instantsearch.widgets.currentRefinements({
    container: '#current-refinements'
  });
  const vendorRefinement = instantsearch.widgets.refinementList({
    container: '#js-refinements-brands',
    attribute: 'vendor',
    sortBy: ['count'],
    limit: 2000,
    transformItems(items) {
      const productVendorContainer = document.querySelector(
        '.refinement__product-vendor'
      );
      productVendorContainer.style.display =
        items.length > 1 ? 'block' : 'none';
      return items;
    }
  });
  const typeRefinement = instantsearch.widgets.refinementList({
    container: '#js-refinements-types',
    attribute: 'product_type',
    sortBy: ['count'],
    limit: 2000,
    transformItems(items) {
      const productTypeContainer = document.querySelector(
        '.refinement__product-type'
      );
      productTypeContainer.style.display = items.length > 1 ? 'block' : 'none';
      return items;
    }
  });
  const colorRefinement = instantsearch.widgets.refinementList({
    container: '#js-refinements-colors',
    attribute: 'options.color',
    limit: 15,
    showMoreLimit: 100,
    sortBy: ['count'],
    showMore: true,
    transformItems(items) {
      const filteredItems = items.filter(
        item => !item.value.toLowerCase().includes('discontinued')
      );

      const finalItems = filteredItems.map(item => ({
        ...item
      }));

      const productColorContainer = document.querySelector(
        '.refinement__product-color'
      );
      productColorContainer.style.display =
        finalItems.length > 1 ? 'block' : 'none';

      return finalItems;
    },
    templates: {
      showMoreText,
      item: colorItemsTemplate
    }
  });
  const sizeRefinement = instantsearch.widgets.refinementList({
    container: '#js-refinements-sizes',
    attribute: 'options.size',
    limit: 2000,
    sortBy: (a, b) =>
      sizeRefinementOrder.indexOf(a.name) - sizeRefinementOrder.indexOf(b.name),
    transformItems(items) {
      const productSizeContainer = document.querySelector(
        '.refinement__product-size'
      );
      productSizeContainer.style.display = items.length > 1 ? 'block' : 'none';
      return items;
    },
    templates: {
      item: sizeItemsTemplate
    }
  });
  const { connectSortBy } = instantsearch.connectors;
  const customSortBy = connectSortBy(renderSortBy);

  const sortBy = customSortBy({
    container: document.querySelector('#sort-by'),
    items: SORT_OPTIONS
  });
  const sortByMobile = customSortBy({
    container: document.querySelector('#sort-by-mobile'),
    items: SORT_OPTIONS
  });

  const gendersRefinement = instantsearch.widgets.refinementList({
    container: '#js-refinements-gender',
    attribute: 'tags',
    limit: 2000,
    sortBy: ['count'],
    transformItems(items) {
      const filteredItems = items.filter(item => {
        return item.value === 'Shop: Women' || item.value === 'Shop: Men';
      });

      const finalItems = filteredItems.map(item => ({
        ...item,
        highlighted: item.highlighted.split('Shop: ')[1]
      }));

      const genderContainer = document.querySelector(
        '.refinement__tags--gender'
      );

      if (filteredItems.length) {
        genderContainer.style.display = 'block';
      } else {
        genderContainer.style.display = 'none';
      }

      return finalItems;
    }
  });

  const saleRefinement = instantsearch.widgets.refinementList({
    container: '#js-refinements-sale',
    attribute: 'tags',
    limit: 2000,
    transformItems(items) {
      const $saleRefinementContainer = document.querySelector(
        '.js-product-sale-refinement'
      );
      const filteredItems = items.filter(
        item => item.value.toLowerCase() === 'sale-collection'
      );
      if (
        collection &&
        (!filteredItems ||
          filteredItems.length < 1 ||
          collection.toLowerCase().includes('sale'))
      ) {
        $saleRefinementContainer.style.display = 'none';
      } else {
        $saleRefinementContainer.style.display = 'block';
      }

      const finalItems = filteredItems.map(item => ({
        ...item,
        highlighted: 'On Sale'
      }));

      const $categoryLabels = document.querySelectorAll(
        '.ais-CurrentRefinements-categoryLabel'
      );
      [...$categoryLabels].forEach(label => {
        if (label.innerText.toLowerCase().indexOf('sale') !== -1) {
          label.innerText = 'Sale';
        }
      });

      return finalItems;
    }
  });
  const widgets = [
    configure,
    search_searchResults,
    clearRefinements,
    currentRefinements,
    vendorRefinement,
    typeRefinement,
    colorRefinement,
    sizeRefinement,
    gendersRefinement,
    saleRefinement,
    sortBy,
    sortByMobile
  ];
  if (!collection) {
    const search_stats = instantsearch.widgets.stats({
      container: '#search-stats',
      templates: {
        text(data) {
          let text = '';

          if (data.hasManyResults) {
            // const start = data.page === 0 ? '1' : data.hitsPerPage * data.page + 1
            const end =
              data.nbHits <= data.hitsPerPage * (data.page + 1)
                ? data.nbHits
                : data.hitsPerPage * (data.page + 1);
            text = `Viewing ${end} of ${data.nbHits} products`;
          } else if (data.hasOneResult) {
            text = `1 result`;
          } else {
            text = `No results`;
          }

          return text;
        }
      }
    });
    const search_searchBox = instantsearch.widgets.searchBox({
      container: '#search-searchbox',
      placeholder: 'What are you looking for?',
      showSubmit: false
    });
    widgets.push(search_searchBox, search_stats);
  }
  if (collection === 'ugly-sweaters') {
    const labelMap = {
      'ugly-nsfw': 'NSFW',
      'ugly-popculture': 'Pop Culture',
      'ugly-sports': 'Sports',
      'ugly-ourpicks': 'Our Picks'
    };
    const tagsRefinement = instantsearch.widgets.refinementList({
      container: '#js-refinements-tags',
      attribute: 'tags',
      limit: 500,
      sortBy: ['count'],
      showMore: false,
      transformItems(items) {
        const filteredItems = items.filter(item =>
          item.value.startsWith('ugly-')
        );
        const finalItems = filteredItems.map(item => ({
          ...item,
          highlighted: labelMap[item.highlighted]
        }));
        return finalItems;
      }
    });
    widgets.push(tagsRefinement);
  }
  if (collection === 'football' || collection === 'florida') {
    const cityTagsRefinement = instantsearch.widgets.refinementList({
      container: '#js-refinements-tags',
      attribute: 'tags',
      limit: 500,
      sortBy: ['count'],
      showMore: false,
      transformItems(items) {
        const filteredItems = items.filter(item =>
          item.value.startsWith('City:')
        );
        const finalItems = filteredItems.map(item => ({
          ...item,
          highlighted: item.highlighted.split('City: ')[1]
        }));

        const container = document.querySelector('.refinement__tags');
        const title = container.querySelector('.refinement__title');
        container.style.display = finalItems.length > 1 ? 'block' : 'none';
        title.textContent = 'City';

        return finalItems;
      }
    });
    widgets.push(cityTagsRefinement);
  }

  search.addWidgets(widgets);
  search.use(insightsMiddleware);
  search.on('error', ({ error }) => {
    console.error(error);
  });
  search.on('render', async p => {
    // Check if in Algolia A/B test
    if (search.renderState[indexName].infiniteHits?.results?.abTestID) {
      // Set GTM properties to track test variant group
      window.dataLayer.push({
        algoliaIndexUsed: indexName,
        algoliaABTestID: `${search.renderState[indexName].infiniteHits.results.abTestID}`,
        algoliaABTestVariantID: `${search.renderState[indexName].infiniteHits.results.abTestVariantID}`,
        event: 'algoliaSearchInformation'
      });
    }
    // Set filter count
    const filterCount = search.renderState[
      indexName
    ].currentRefinements?.items?.reduce((total, item) => {
      return total + item.refinements.length;
    }, 0);
    if (filterCount) {
      document.querySelector('#filters-count').textContent = `(${filterCount})`;
    } else {
      document.querySelector('#filters-count').textContent = '';
    }
    // Save queryID for algolia events
    if (search.renderState[indexName].infiniteHits?.results?.queryID) {
      localStorage.setItem(
        'queryID',
        search.renderState[indexName].infiniteHits.results.queryID
      );
    }
    // List of IDs to fetch from GraphQL request to enrich product card
    const ids = search.renderState[indexName].infiniteHits.currentPageHits.map(
      hit => `gid://shopify/Product/${hit.id}`
    );
    const { data } = await getProductsByIds(ids);
    enrichProducts(data);
  });
  search.start();

  $(document).ready(function () {
    $('.refinement__header').on('click', function () {
      $(this).parent('.refinement').toggleClass('refinement--open');
    });
    $('#filters-toggle').on('click', function () {
      $('body').addClass('filters-open');
    });
    $('.filters-overlay, .filters-apply').on('click', function () {
      $('body').removeClass('filters-open');
    });
  });
}
